import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import SmoothScroll from "./SmoothScroll";
import { WhatsAppButton } from "./WhatsAppButton";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <SmoothScroll>
      <div className="App bg-[#0A0A0A] min-h-screen">
        <Toaster theme="dark" position="top-center" richColors />
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </SmoothScroll>
  );
}
